
import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import {
	NAME as name,
	DEPENDENT_TABLES_ALL as depTableNames,
	CRUMB_LABEL_KEY,
	ZAKAZKAND_PREDCHUDCE,
	ZAKAZKAND_SHODA,
	ZAKAZKAND_NASLEDNICI, ZAKAZKAND_POHYB, ZAKAZKAND_MOZNO_VYDAT, ZAKAZKAND_CAMPAIGN,
} from '../../constants';
import { apiProvider } from '../../api';
import { dropdownList, edit, localState, props } from './state';
import { actions as extraActions } from './actions';
import { mutations as extraMutations } from './mutations';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames,
	depTableSettings: {
		[ZAKAZKAND_PREDCHUDCE]: {
			filter(state) {
				return {
					VyrobekndOzn: state.edit.VyrobekndOzn,
					NdNr: state.edit.NdNr,
					NaskladePrp: false,
				};
			},
		},
		[ZAKAZKAND_SHODA]: {
			filter(state) {
				return {
					VyrobekndOzn: state.edit.VyrobekndOzn,
					NdNr: state.edit.NdNr,
					NaskladePrp: false,
				};
			},
		},
		[ZAKAZKAND_NASLEDNICI]: {
			filter(state) {
				return {
					VyrobekndOzn: state.edit.VyrobekndOzn,
					NdNr: state.edit.NdNr,
					NaskladePrp: false,
				};
			},
		},
		[ZAKAZKAND_POHYB]: {
			filter(state) {
				return {
					SkladOzn: state.edit.SkladOzn,
					ZakazkaId: state.edit.ZakazkaId,
					VyrobekndOzn: state.edit.VyrobekndOzn,
					NdNr: state.edit.NdNr,
				};
			},
		},
		[ZAKAZKAND_MOZNO_VYDAT]: {
			filter(state): any {
			if (state.edit.ZakazkaId === undefined || (typeof state.edit.ZakazkaId === 'string' && state.edit.ZakazkaId === '')) {
            return;
        }
				return {
					ZakazkaId: state.edit.ZakazkaId,
					VyrobekndOzn: state.edit.VyrobekndOzn,
					NdNr: state.edit.NdNr,
					ZakazkandextodpisId: state.edit.ZakazkandextodpisId,
				};
			},
		},
		[ZAKAZKAND_CAMPAIGN]: {
			filter(state): any {
			const zaznamId = state.edit.ZaznamId;
			if (zaznamId == undefined || (typeof zaznamId === 'string' && zaznamId === '')) {
				return;
			}
			return {
				ZAKAZKAND_PKID: zaznamId,
			};
		},
	},
},
	localState,
	extraActions,
	extraGetters: {},
	extraMutations,
	props,
});
